import { BaseCard, Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";

interface MockHorizontalCardProps {
  id: string;
  maxWidth?: SizeDimension;
}
export const MockHorizontalCard = ({
  id,
  maxWidth = 164,
}: MockHorizontalCardProps) => {
  return (
    <BaseCard maxWidth={maxWidth} testID={id}>
      <Box backgroundColor={ColorToken.NeutralLine} height={100} width="100%" />
    </BaseCard>
  );
};
